const TermsAgreement = {
  'pages_terms_TermsAgreement.1': '약관 동의',
  'pages_terms_TermsAgreement.2': '서비스 약관, 개인정보 수집 및 이용에 동의 후 이용해 주세요.',
  'pages_terms_TermsAgreement.checkbox.1': '서비스 약관 동의 *',
  'pages_terms_TermsAgreement.checkbox.2': '개인정보 처리 방침 *',
  'pages_terms_TermsAgreement.checkbox.3': '전체 약관 동의하기 *',
}

export default TermsAgreement



// WEBPACK FOOTER //
// ./src/lang/terms/TermsAgreement.kr.js